import { useQuery } from '@tanstack/react-query';
import { OilSupplierService, OilStoreTypeEntity } from 'services/openapi';
import { OilSupplierQueryKeys } from './constants';

export const useGetAllOilSuppliersQuery = () => {
  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery({
    queryKey: [OilSupplierQueryKeys.GET_OIL_SUPPLIERS],
    queryFn: () => OilSupplierService.oilSupplierControllerGetAllSimple(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    error,
    // The generated simple response incorrectly declares string[] for supplier objects.
    data: data?.data as unknown as OilStoreTypeEntity[] | undefined,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};
